import { call, take, put, takeLeading } from 'redux-saga/effects';
import { get, post, putMethod, deleteMethod } from '../../utils/api';
import settings from '../../utils/settings';
import {
  ADMIN_PANEL_REQUEST,
  ADMIN_PANEL_SUCCESS,
  ADMIN_PANEL_FAILURE,
  ADMIN_DETAILS_REQUEST,
  ADMIN_DETAILS_FAILURE,
  ADMIN_DETAILS_CREATE_REQUEST,
  ADMIN_DETAILS_CREATE_SUCCESS,
  ADMIN_DETAILS_CREATE_FAILURE,
  ADMIN_DETAILS_UPADTE_REQUEST,
  ADMIN_DETAILS_UPADTE_SUCCESS,
  ADMIN_DETAILS_UPADTE_FAILURE,
  ADMIN_DETAILS_DELETE_REQUEST,
  ADMIN_DETAILS_DELETE_SUCCESS,
  ADMIN_DETAILS_DELETE_FAILURE,
  PRODUCT_ACCESS_REQUEST,
  PRODUCT_ACCESS_SUCCESS,
  PRODUCT_ACCESS_FAILURE,
  DIGITAL_ASSETS_SUCCESS,
  PRODUCT_INFO_SUCCESS,
  EXCLUSIVE_SUCCESS,
  HEADER_LINK_SUCCESS,
  UPLOAD_EIN_FILE_REQUEST,
  UPLOAD_FILE_FAILURE,
  SAMPLE_DATA_REQUEST,
  SAMPLE_DATA_SUCCESS,
  SAMPLE_DATA_FAILURE,
  PUT_EIN_S3_URL_REQUEST,
  UPLOAD_EIN_FILE_SUCCESS,
  GET_ENLM_FEEDBACK_CSV_DATA_REQUEST,
  GET_ENLM_FEEDBACK_CSV_DATA_SUCCESS,
  GET_ENLM_FEEDBACK_CSV_DATA_FAILURE
} from './constants';
import { getToken } from '../../utils/helper';
import { isEmpty } from '../../utils/lodash';

export function* getAllAdminPanelDetails() {
  while (true) {
    const request = yield take(ADMIN_PANEL_REQUEST);
    try {
      let response;
      const { country = 'US' } = request.payload;
      response = yield call(get, {
        url: settings.einCoreUrl(`admin/${country}`),
        withBearer: true
      });
      if (response.success) {
        const { header_bar_links, digital_assets, exclusive_updates, product_information } = response.result;
        yield put({
          type: ADMIN_PANEL_SUCCESS,
          headerBarDetails: header_bar_links,
          digitalAssetsDetails: digital_assets,
          exclusiveDetails: exclusive_updates,
          productInfoDetails: product_information
        });
      } else {
        yield put({ type: ADMIN_PANEL_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getAllAdminPanelDetails:', error);
      yield put({ type: ADMIN_PANEL_FAILURE, error: error });
    }
  }
}

export function* getAdminDetails() {
  while (true) {
    const request = yield take(ADMIN_DETAILS_REQUEST);
    try {
      let response;
      const { key, country = 'US' } = request.payload;
      response = yield call(get, {
        url: settings.einCoreUrl(`admin/${key}/${country}`),
        withBearer: true
      });
      if (response.success) {
        if (key === 'digitalAssets') {
          yield put({ type: DIGITAL_ASSETS_SUCCESS, digitalAssetsDetails: response.result });
        }
        if (key === 'productInformation') {
          yield put({ type: PRODUCT_INFO_SUCCESS, productInfoDetails: response.result });
        }
        if (key === 'exclusiveUpdates') {
          yield put({ type: EXCLUSIVE_SUCCESS, exclusiveDetails: response.result });
        }
        if (key === 'headerBarLinks') {
          yield put({ type: HEADER_LINK_SUCCESS, headerBarDetails: response.result });
        }
      } else {
        yield put({ type: ADMIN_DETAILS_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getAdminDetails:', error);
      yield put({ type: ADMIN_DETAILS_FAILURE, error: error });
    }
  }
}

export function* createAdminDetails() {
  while (true) {
    const request = yield take(ADMIN_DETAILS_CREATE_REQUEST);
    try {
      let response;
      const { data, key, successCbk = () => {}, country = 'US' } = request.payload;
      response = yield call(post, {
        url: settings.einCoreUrl(`admin/${key}/${country}`),
        body: data,
        withBearer: true
      });
      if (response.success) {
        yield put({ type: ADMIN_DETAILS_CREATE_SUCCESS });
        successCbk(response.result);
      } else {
        yield put({ type: ADMIN_DETAILS_CREATE_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: createAdminDetails:', error);
      yield put({ type: ADMIN_DETAILS_CREATE_FAILURE, error: error });
    }
  }
}

export function* updateAdminDetails() {
  while (true) {
    const request = yield take(ADMIN_DETAILS_UPADTE_REQUEST);
    try {
      let response;
      const { data, id, key, successCbk = () => {} } = request.payload;
      response = yield call(putMethod, {
        url: settings.einCoreUrl(`admin/${key}/${id}`),
        body: data,
        withBearer: true
      });
      if (response.success) {
        yield put({ type: ADMIN_DETAILS_UPADTE_SUCCESS });
        successCbk(response.result);
      } else {
        yield put({ type: ADMIN_DETAILS_UPADTE_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: updateAdminDetails:', error);
      yield put({ type: ADMIN_DETAILS_UPADTE_FAILURE, error: error });
    }
  }
}

export function* einOptOut() {
  while (true) {
    const request = yield take(UPLOAD_EIN_FILE_SUCCESS);
    try {
      let response;
      if (request.payload.type === 'installer_setup') {
        response = yield call(post, {
          url: settings.einCoreUrl(`admin/einOptOut`),
          body: {},
          withBearer: true
        });
      }
    } catch (error) {
      console.log('Saga: einOptOut:', error);
    }
  }
}

export function* deleteAdminDetails() {
  while (true) {
    const request = yield take(ADMIN_DETAILS_DELETE_REQUEST);
    try {
      let response;
      const { id, key, successCbk = () => {} } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.einCoreUrl(`admin/${key}/${id}`),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: ADMIN_DETAILS_DELETE_SUCCESS });
        successCbk();
      } else {
        yield put({ type: ADMIN_DETAILS_DELETE_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: deleteAdminDetails:', error);
      yield put({ type: ADMIN_DETAILS_DELETE_FAILURE, error: error });
    }
  }
}

export function* getProductAccessList() {
  while (true) {
    yield take(PRODUCT_ACCESS_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`admin/productAccess`),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: PRODUCT_ACCESS_SUCCESS, productAccessList: response.result.data });
      } else {
        yield put({ type: PRODUCT_ACCESS_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getProductAccessList:', error);
      yield put({ type: PRODUCT_ACCESS_FAILURE, error: error });
    }
  }
}

export function* einDataUpload() {
  while (true) {
    const request = yield take(UPLOAD_EIN_FILE_REQUEST);
    try {
      const { type = 'installer_setup', file, successCbk = () => {}, failureCbk = () => {} } = request.payload;
      var formData = new FormData();
      formData.append('file', file, file.name);
      formData.append('type', type);
      var requestOptions = {
        method: 'PUT',
        body: formData,
        headers: { Authorization: `${getToken()}` }
      };
      fetch(settings.getApiUrl(`api_internal/admin/ein_data_upload`), requestOptions)
        .then(data =>
          data.json().then(response => {
            const { success, success_list = [], status_code, error_list = [], message } = response;
            if (success && !isEmpty(success_list)) {
              successCbk({
                type,
                errorList: error_list,
                successList: success_list,
                message: !isEmpty(error_list) ? message : ''
              });
            } else {
              failureCbk({ type, statusCode: status_code, errorList: error_list });
            }
          })
        )
        .catch(error => {
          failureCbk({ type, statusCode: error, errorList: [] });
        });
    } catch (error) {
      console.log('Saga: einDataUpload:', error);
      yield put({ type: UPLOAD_FILE_FAILURE, error: error });
    }
  }
}

export function* getSampleFileFields() {
  while (true) {
    yield take(SAMPLE_DATA_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl('api_internal/admin/ein_data_upload_fields')
      });
      if (response.success) {
        yield put({
          type: SAMPLE_DATA_SUCCESS,
          installerSetupHeaders: response.result.installer_setup_headers,
          installerUpdateHeaders: response.result.installer_update_headers
        });
      } else {
        yield put({ type: SAMPLE_DATA_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getSampleFileFields', error);
      yield put({ type: SAMPLE_DATA_FAILURE, error });
    }
  }
}

let putS3loading = false;

// eslint-disable-next-line require-yield
function* uploadToS3Flow(action) {
  if (!putS3loading) {
    putS3loading = true;
    const { preSignedS3Url, fileObj, successCbS3, failureCbS3 } = action.payload;
    try {
      var requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': fileObj.type },
        body: fileObj
      };
      fetch(preSignedS3Url, requestOptions).then(function(data) {
        const { status } = data;
        if (status === 200) {
          successCbS3();
        } else {
          failureCbS3();
        }
        putS3loading = false;
      });
    } catch (error) {
      failureCbS3();
      putS3loading = false;
    }
  }
}

export function* watchLastEinPutS3Flow() {
  yield takeLeading(PUT_EIN_S3_URL_REQUEST, uploadToS3Flow);
}

export function* getEnlmFeedbacksCsvData() {
  while (true) {
    yield take(GET_ENLM_FEEDBACK_CSV_DATA_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`admin/enlmFeedbacks`),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: GET_ENLM_FEEDBACK_CSV_DATA_SUCCESS, enlmFeedbacksCsvData: response.result.data });
      } else {
        yield put({ type: GET_ENLM_FEEDBACK_CSV_DATA_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getEnlmFeedbacksCsv Admin:', error);
      yield put({ type: GET_ENLM_FEEDBACK_CSV_DATA_FAILURE, error: error });
    }
  }
}
